type BreakPoints = {
    [key: string]: number
}

const breakPoints: BreakPoints = {
    '128px': 128,
    '256px': 256,
    '320px': 320,
    '448px': 448,
    'xs': 576,
    'sm': 640,
    'md': 768,
    'lg': 1024,
    'xl': 1280,
    '2xl': Infinity,
}

export function handleClasses(element: HTMLElement, width: number, expression: null | string = null): void {
    const breakPoint = getClosestBreakPoint(element, width);

    if (!breakPoint && expression) {
        return setClasses(element, expression);
    }

    if (breakPoint) {
        setClasses(element, element.getAttribute(breakPoint));
    } else {
        removeOldClasses(element);
    }
}

function getClosestBreakPoint(element: HTMLElement, width: number): null | string {
    let closestBreakPoint: null | string = null;

    getBreakPoints(element).forEach(([name, value]) => {
        if (width >= value && element.getAttribute(name)) {
            closestBreakPoint = name;
        }
    })

    return closestBreakPoint;
}

function removeOldClasses(element: HTMLElement): void {
    const classes = element.getAttribute('x-responsive-classes');

    if (classes) {
        element.classList.remove(...classes.split(' '));
    }
}

function setClasses(element: HTMLElement, classes: null | string): void {
    removeOldClasses(element);

    if (!classes) return

    element.setAttribute('x-responsive-classes', classes);
    element.classList.add(...classes.split(' '));
}

function getBreakPoints(element: HTMLElement): [string, number][] {
    return Object.entries({ ...breakPoints, ...getDynamicBreakPoints(element) })
        .sort(([, a], [, b]) => a - b)
}

function getDynamicBreakPoints(element: HTMLElement): BreakPoints {
    const attributes = {};

    element.getAttributeNames().filter((attributeName) => attributeName.startsWith('responsive:'))
        .forEach((attribute) => {
            const value = attribute.split('responsive:')[1]

            attributes[attribute] = parseInt(value, 10)
        })

    return attributes;
}